/**
 * Pure helpers for showing a legal document, the privacy notice (#289) or the Terms and Conditions (0181): which
 * text for the reader, and its paragraphs.
 */

/** The two texts of a legal document (the privacy notice, the Terms and Conditions). */
export interface BilingualText {
  body_en: string;
  body_es: string | null;
}

/** The text in the reader's language, falling back to English when no Spanish text is published. */
export function noticeBody(notice: BilingualText, language: 'en' | 'es'): string {
  return language === 'es' && notice.body_es ? notice.body_es : notice.body_en;
}

/** The text as paragraphs: blank lines separate them, single line breaks stay inside one. */
export function noticeParagraphs(body: string): string[] {
  const paragraphs: string[] = [];
  let lines: string[] = [];
  const close = (): void => {
    if (lines.length > 0) paragraphs.push(lines.join(' '));
    lines = [];
  };
  for (const line of body.split('\n')) {
    const text = line.trim();
    if (text === '') close();
    else lines.push(text);
  }
  close();
  return paragraphs;
}
